module.exports = __webpack_public_path__ + "assets/67969af4ea814abfcf7a1021a4eb604b.png";